const LOCAL_API_URL = "https://localhost:44300/api/";

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  API_URL: process.env.REACT_APP_API_URL || LOCAL_API_URL,
};
